// extracted by mini-css-extract-plugin
module.exports = {"dfp":"dfp-ad-horizontal-m__dfp__2MBLZ"};